import Vue from 'vue'
import 'jquery'
import 'babel-polyfill'
import App from './App'
import router from './router'
import {Tabbar,TabItem,Search,Swipe,SwipeItem,Button,Cell,Header,Field,Radio,Popup,Picker,InfiniteScroll,Spinner,Switch} from 'mint-ui'
import Qs from 'qs'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import './assets/css/my-mint.scss';

Vue.config.productionTip = false

Vue.prototype.URL_PREFIX = 'http://bz.vsofo.com/api'  //192.168.0.48
Vue.prototype.URL_PREFIX_IMG = 'http://bz.vsofo.com/'
//Vue.prototype.URL_PREFIX = 'http://192.168.0.48:8088/mob/api'  //192.168.0.48
//Vue.prototype.URL_PREFIX_IMG = 'http://192.168.0.48:8088/mob'
Vue.prototype.URL_PAY='http://m.vcard8.com/payState.html'
Vue.prototype.URL_PAY_H='http://m.vcard8.com/paysucceState.html'
Vue.prototype.Act_Cname='vsofo'
Vue.prototype.Act_md5sign='VSOFO#5ccb66257a6f590f@20180821$'
//在Vue的原型上加了属性
//Vue.prototype.$event = new Vue();

Vue.prototype.$http = axios
var axios_instance = axios.create({
  //baseURL:'http://localhost',
  transformRequest: [function (data) {  
    data = Qs.stringify(data);
    return data;
  }],
  headers:{'Content-Type':'application/x-www-form-urlencoded'}
})
Vue.use(VueAxios, axios_instance)
Vue.use(VueAwesomeSwiper)
Vue.use(InfiniteScroll);   

Vue.component(Tabbar.name, Tabbar);
Vue.component(TabItem.name, TabItem);
Vue.component(Search.name, Search);
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.component(Button.name, Button);
Vue.component(Cell.name, Cell);
Vue.component(Header.name, Header);
Vue.component(Field.name, Field);
Vue.component(Radio.name, Radio);
Vue.component(Popup.name, Popup);
Vue.component(Picker.name, Picker);
Vue.component(Spinner.name, Spinner);
Vue.component(Switch.name, Switch);

router.beforeEach((to, from, next) => {
	if(to.meta.requireAuth){
	 Vue.prototype.$http.post(Vue.prototype.URL_PREFIX+'/user/isUserLogin.net',{phone:localStorage.getItem("username")})
	 .then(function(res){
		if (res.data.code==200) {  
           next();
           localStorage.setItem("username",res.data.obj);
        }
        else {
            next({
                path: '/Login',
                query: {redirect: to.fullPath}  
            });
            localStorage.removeItem("username");
        }
    });
	}else{
		next();
	}
});

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js